import { ApiResponse } from './index'
import api from './index'

export async function fetchReportMetadata(params: Record<string, unknown>): Promise<{
  estimatedRows: number
  estimatedSizeBytes: number
  estimatedDurationSeconds: number
  estimatedDurationLabel: string
}> {
  const res: ApiResponse = await api.makeRequest({
    method: 'POST',
    url: 'reports/meta',
    data: params
  })
  return res.data
}

export async function fetchReportList(page: number, limit: number, organizationId?: string): Promise<{
  items: any[]
  total: number
  page: number
  limit: number
  totalPages: number
}> {
  let url = `reports?page=${page}&limit=${limit}`
  if (organizationId) url += `&organizationId=${encodeURIComponent(organizationId)}`
  const res: ApiResponse = await api.makeRequest({
    method: 'GET',
    url
  })
  return res.data
}

export async function deleteReport(id: string): Promise<ApiResponse> {
  return api.makeRequest({
    method: 'DELETE',
    url: `reports/${id}`
  })
}

export function getReportDownloadUrl(id: string): string {
  return `${process.env.VUE_APP_API_PATH || ''}/reports/${id}/download`
}

export function formatFileSize(bytes: number): string {
  if (bytes === 0) return '-'
  if (bytes < 1024) return `${bytes} o`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} Ko`
  return `${(bytes / (1024 * 1024)).toFixed(1)} Mo`
}
